import { render, staticRenderFns } from "./OrderDeliverBtn.vue?vue&type=template&id=5f5dcb04&"
import script from "./OrderDeliverBtn.vue?vue&type=script&lang=js&"
export * from "./OrderDeliverBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports